import { rulesConstants } from "../constants/rulesConstants"

const initialState = {
  rules: []
}

export function rules(state = initialState, action) {
  switch (action.type) {
    case rulesConstants.GET_RULES_REQUEST:
      return {
        ...state,
        fetchingRules: true
      }

    case rulesConstants.GET_RULES_FAILURE:
      return {
        ...state,
        rulesFetchError: action.error
      }

    case rulesConstants.GET_RULES_SUCCESS:
      return {
        ...state,
        fetchingRules: false,
        rules: action.rules
      }

    case rulesConstants.ADD_LESSON_RULES_REQUEST:
    case rulesConstants.UPDATE_LESSON_RULES_REQUEST:
      return {
        ...state,
        updatingLessonRules: true
      }

    case rulesConstants.ADD_LESSON_RULES_SUCCESS:
    case rulesConstants.UPDATE_LESSON_RULES_SUCCESS:
      return {
        ...state,
        updatingLessonRules: false
      }

    case rulesConstants.ADD_LESSON_RULES_FAILURE:
    case rulesConstants.UPDATE_LESSON_RULES_FAILURE:
      return {
        ...state,
        updatingLessonRules: false,
        updatingLessonRulesError: action.error
      }

    case rulesConstants.UPDATE_LESSON_RULE_REQUEST:
      return {
        ...state,
        updatingLessonRule: true,
        updatingRuleId: action.ruleId
      }

    case rulesConstants.UPDATE_LESSON_RULE_SUCCESS:
      return {
        ...state,
        updatingLessonRule: false,
        updatingRuleId: null
      }

    case rulesConstants.UPDATE_LESSON_RULE_FAILURE:
      return {
        ...state,
        updatingLessonRule: false,
        updatingLessonRuleError: action.error
      }

    case rulesConstants.DELETE_LESSON_RULE_REQUEST:
      return {
        ...state,
        deletingLessonRule: true,
        updatingRuleId: action.ruleId
      }

    case rulesConstants.DELETE_LESSON_RULE_SUCCESS:
      return {
        ...state,
        deletingLessonRule: false,
        updatingRuleId: null
      }

    case rulesConstants.DELETE_LESSON_RULE_FAILURE:
      return {
        ...state,
        deletingLessonRule: false,
        deletingLessonRuleError: action.error
      }

    default:
      return state
  }
}
